import { render, staticRenderFns } from "./app-auth-page.vue?vue&type=template&id=9d2e9110&scoped=true&"
import script from "./app-auth-page.vue?vue&type=script&lang=js&"
export * from "./app-auth-page.vue?vue&type=script&lang=js&"
import style0 from "./app-auth-page.vue?vue&type=style&index=0&id=9d2e9110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2e9110",
  null
  
)

export default component.exports